import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { AvailableOsUpdatesEffects } from './available-os-updates.effect';
import { AvailableOsUpdatesReducer, availableOsUpdatesFeatureKey } from './available-os-updates.reducer';

export const provideAvailableOsUpdatesStore = () => [
  provideState(availableOsUpdatesFeatureKey, AvailableOsUpdatesReducer),
  provideEffects([AvailableOsUpdatesEffects]),
];
